import { Button, Stack } from "@mui/material";
// @ts-ignore
import QR from "../img/boton-qr.png";

export default function BotonQr({ handleOpen }) {
  return (
    <Stack
      sx={{
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Button
        sx={{
          width: "85px",
          height: "85px",
          padding: "0px",
          marginBottom: 5,
          borderRadius: "10px",
          boxShadow: "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;"
        }}
        onClick={handleOpen}
      >
        <img
          width="100%"
          height="100%"
          src={QR}
          alt=""
          style={{
            borderRadius: "10px",
          }}
        />
      </Button>
    </Stack>
  );
}
